// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const aegislash_blade: PokeData = {
  "id": 10026,
  "name": "aegislash-blade",
  "height": 17,
  "weight": 530,
  "base_experience": 250,
  "types": [
    PokeType.STEEL,
    PokeType.GHOST
  ],
  "api_moves": [
    "swords-dance",
    "tackle",
    "slash",
    "fury-cutter",
    "pursuit",
    "metal-sound",
    "aerial-ace",
    "iron-defense",
    "power-trick",
    "night-slash",
    "shadow-sneak",
    "iron-head",
    "head-smash",
    "autotomize",
    "retaliate",
    "sacred-sword",
    "kings-shield"
  ],
  "moves": [
    "tackle",
    "pursuit",
    "metal-sound",
    "aerial-ace",
    "night-slash",
    "shadow-sneak",
    "metal-claw",
    "magnet-bomb",
    "iron-defense",
    "smart-strike",
    "metal-rush",
    "scrap-throw",
    "confuse-ray"
  ],
  "evolution_chain": {
    "id": 349,
    "item": null,
    "species": [
      {
        "name": "honedge",
        "order": 680,
        "types": [
          PokeType.STEEL,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "doublade",
        "order": 681,
        "types": [
          PokeType.STEEL,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 679,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "aegislash",
        "order": 682,
        "types": [
          PokeType.STEEL,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 680,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "dusk-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 86,
    "speed": 94,
    "ability_power": 220
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
